const pagesAuthInvitationEn = {
  acceptInvitationSuccessfulMessage: '🎉 Successfully created account!',
  agree: 'Checking here, You have read and agree to our <termsOfUseLink>Terms of Service</termsOfUseLink> and <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.',
  email: 'Email',
  firstOrGivenName: 'First or given name',
  lastOrFamilyName: 'Last or family name',
  middleName: 'Middle name',
  pageSubtitle: 'Already have an account?',
  pageSubtitleLink: 'Sign in',
  pageTitle: 'Create account',
  password: 'Create Password',
  passwordErrorMessage: 'Password must be 10 letters long with both letters and numbers and special characters (e.g. ^$*.[]{}()?"!@#%&/\\,><\':;|_~`=+-)',
  passwordPlaceholder: 'Enter your password',
  passwordRequirement: 'At least 10 characters with letters, numbers, and special characters (e.g. ^$*.[]{}()?"!@#%&/\\,><\':;|_~`=+-)',
  showPassword: 'Show password',
  ssoRequired: {
    description: 'This organization requires SSO sign-in. Use the button below to sign in with Microsoft.',
    loginError: 'Could not start SSO sign-in. Please try again.',
    signInButton: 'Sign in with Microsoft'
  },
  submitButton: 'Create account'
};
export default pagesAuthInvitationEn;